import { useUrlFilterParams } from 'common/hooks/useUrlFilterParams';

export const useScormFilter = (filterParamsInUrl = true) => {
    const { filterParams, setFilterParam } = useUrlFilterParams(
        'scorm',
        filterParamsInUrl
    );

    const searchQueryParam = filterParams.q || '';

    const handleSearch = (searchValue: string) => {
        setFilterParam('q', searchValue);
    };

    return {
        filterValues: { q: searchQueryParam },
        handleSearch,
    };
};
